import { Record } from 'immutable';

export default Record({
    body: '',
    campaignId: null,
    filterDisposables: true,
    from: 'Get Your Promo',
    id: null,
    requireConfirmation: true,
    subject: 'Your Coupon Code',
});



// WEBPACK FOOTER //
// ./src/records/emailSettings.js